/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrganizationDetailsResponse } from '../../models/get-organization-details-response';

export interface GetOrganizationsById$Params {
  organizationId: string;
}

export function getOrganizationsById(http: HttpClient, rootUrl: string, params: GetOrganizationsById$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrganizationDetailsResponse>> {
  const rb = new RequestBuilder(rootUrl, getOrganizationsById.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrganizationDetailsResponse>;
    })
  );
}

getOrganizationsById.PATH = '/api/v3/{organizationId}';
